import type { AalReason } from '@app/hooks/useAal'
import { roundForDisplay } from '@app/components/Molecules/Charts/utils/utils'

const REASON_MESSAGES: Record<AalReason, string> = {
  no_damage_ratio_data:
    'Unable to calculate Event Set AAL - damage ratios are not available for this asset element.',
  insufficient_scenarios:
    'Unable to calculate Event Set AAL - fewer than three modelled return periods are available for this hazard model.',
  missing_replacement_cost:
    'Unable to calculate Event Set AAL - replacement cost is unavailable for this element.',
}

export const reasonMessage = (reason?: AalReason): string =>
  reason
    ? REASON_MESSAGES[reason]
    : 'Event Set Average Annual Loss Estimate: Trapezoidal integration of loss against annual exceedance probability across the modelled scenarios, plus a conservative rare-tail rectangle for events rarer than the smallest modelled AEP. Min and Max estimates derive from underlying damage curve variability.'

/**
 * Format an [aal_min, aal_max] band as a currency-prefixed range string. The
 * larger bound drives unit selection (k/M/B) so both ends share a common
 * scale: e.g. "$1.2M – $2.4M".
 */
export const formatAalBand = (aal_min: number, aal_max: number, currencySymbol: string): string => {
  const maxAbs = Math.max(Math.abs(aal_min), Math.abs(aal_max))
  const minStr = roundForDisplay(aal_min, '$', maxAbs)
  const maxStr = roundForDisplay(aal_max, '$', maxAbs)
  if (minStr === maxStr) {
    return `${currencySymbol}${maxStr}`
  }
  return `${currencySymbol}${minStr} – ${currencySymbol}${maxStr}`
}
